var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.08 186.88h512v102.4h-512z",
    fill: "#F2E5CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M794.88 302.08h-537.6v-128h537.6v128z m-512-25.6h486.4v-76.8h-486.4v76.8z",
    fill: "#231C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M743.68 378.88c0 14.08-11.52 25.6-25.6 25.6h-384c-14.08 0-25.6-11.52-25.6-25.6v-204.8c0-14.08 11.52-25.6 25.6-25.6h384c14.08 0 25.6 11.52 25.6 25.6v204.8z",
    fill: "#A7BFB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M718.08 417.28h-384c-21.76 0-38.4-16.64-38.4-38.4v-204.8c0-21.76 16.64-38.4 38.4-38.4h384c21.76 0 38.4 16.64 38.4 38.4v204.8c0 21.76-17.92 38.4-38.4 38.4z m-384-256c-7.68 0-12.8 5.12-12.8 12.8v204.8c0 7.68 5.12 12.8 12.8 12.8h384c7.68 0 12.8-5.12 12.8-12.8v-204.8c0-7.68-5.12-12.8-12.8-12.8h-384z",
    fill: "#231C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M346.88 225.28h358.4v268.8h-358.4z",
    fill: "#E1E0A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M718.08 506.88h-384v-294.4h384v294.4z m-358.4-25.6h332.8v-243.2h-332.8v243.2z",
    fill: "#231C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M922.88 698.88c0 14.08-11.52 25.6-25.6 25.6h-742.4c-14.08 0-25.6-11.52-25.6-25.6v-384c0-14.08 11.52-25.6 25.6-25.6h742.4c14.08 0 25.6 11.52 25.6 25.6v384z",
    fill: "#FAC546"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M897.28 737.28h-742.4c-21.76 0-38.4-16.64-38.4-38.4v-384c0-21.76 16.64-38.4 38.4-38.4h742.4c21.76 0 38.4 16.64 38.4 38.4v384c0 21.76-17.92 38.4-38.4 38.4z m-742.4-435.2c-7.68 0-12.8 5.12-12.8 12.8v384c0 7.68 5.12 12.8 12.8 12.8h742.4c7.68 0 12.8-5.12 12.8-12.8v-384c0-7.68-5.12-12.8-12.8-12.8h-742.4z",
    fill: "#231C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M756.48 826.88c0 14.08-11.52 25.6-25.6 25.6h-409.6c-14.08 0-25.6-11.52-25.6-25.6v-256c0-14.08 11.52-25.6 25.6-25.6h409.6c14.08 0 25.6 11.52 25.6 25.6v256z",
    fill: "#F2E5CA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M730.88 865.28h-409.6c-21.76 0-38.4-16.64-38.4-38.4v-256c0-21.76 16.64-38.4 38.4-38.4h409.6c21.76 0 38.4 16.64 38.4 38.4v256c0 21.76-17.92 38.4-38.4 38.4z m-409.6-307.2c-7.68 0-12.8 5.12-12.8 12.8v256c0 7.68 5.12 12.8 12.8 12.8h409.6c7.68 0 12.8-5.12 12.8-12.8v-256c0-7.68-5.12-12.8-12.8-12.8h-409.6z",
    fill: "#231C1C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M346.88 545.28h358.4v256h-358.4z",
    fill: "#E1E0A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M718.08 814.08h-384v-281.6h384v281.6z m-358.4-25.6h332.8v-230.4h-332.8v230.4z",
    fill: "#231C1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M423.68 596.48h204.8v25.6h-204.8z",
    fill: "#231C1C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M423.68 647.68h204.8v25.6h-204.8z",
    fill: "#231C1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M423.68 698.88h204.8v25.6h-204.8z",
    fill: "#231C1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M794.88 340.48h64v25.6h-64z",
    fill: "#231C1C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M732.16 340.48H768v25.6h-35.84z",
    fill: "#231C1C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.28 494.08h793.6v25.6h-793.6z",
    fill: "#231C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.e8f55afbc5802588c9774f255f66d42f.svg";
export { ForwardRef as ReactComponent };